<template>
  <transition name="fadeIn">
    <div v-if="sellerProducts.length" class="sale-products">
      <div class="sale-products__header">
        <p class="sale-products__lead">{{ $t('Discounts') }}</p>

        <div class="sale-products__slider-nav">
          <button type="button" class="button-reset sale-products__prev">
            <ChevronLeft :size="20" />
          </button>
          <button type="button" class="button-reset sale-products__next">
            <ChevronRight :size="20" />
          </button>
        </div>
      </div>

      <div ref="saleProductsSwiper" class="swiper sale-products__slider">
        <div class="swiper-wrapper">
          <div v-for="product in sellerProducts" :key="product.id" class="swiper-slide sale-products__slide">
            <ProductCard :product="product" class="sale-products__product" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ProductCard from '@/components/cards/product/ProductCard.vue'
import { mapState } from 'vuex'
import Swiper, { Navigation } from 'swiper'
import 'swiper/swiper.css'
import { ChevronRight, ChevronLeft } from 'lucide-vue'
import { eventBus } from '@/helpers'
import { Metrics } from '@/utils/metrics'
import { SELLER_PRODUCT_STATUS } from '@/constants'

export default {
  name: 'ProductsOnSale',
  components: {
    ProductCard,
    ChevronRight,
    ChevronLeft,
  },
  computed: {
    ...mapState('profileProduct', ['sellerProducts']),
  },
  async mounted() {
    // Запрашиваем здесь чтобы слайдер инициализировался после прогрузки товаров
    try {
      await this.$store.dispatch('profileProduct/listSellerProducts', {
        status__in: [SELLER_PRODUCT_STATUS.publish, SELLER_PRODUCT_STATUS.not_publish].join(','),
        discount__gt: 0,
      })

      new Swiper(this.$refs.saleProductsSwiper, {
        modules: [Navigation],
        loop: false,
        slidesPerView: 2,
        spaceBetween: 8,
        navigation: {
          prevEl: '.sale-products__prev',
          nextEl: '.sale-products__next',
        },
        breakpoints: {
          576: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 12,
          },
        },
      })

      Metrics.reportProductImpressions(this.sellerProducts)
    } catch (e) {
      console.error(e)
      eventBus.$emit('error', e)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';
@import '@/assets/scss/transitions.scss';

.sale-products {
  &__lead {
    font-size: 20px;
    font-weight: 600;

    @include media-breakpoint-up(sm) {
      font-size: 24px;
    }
  }

  &__slider {
    display: none;

    &.swiper-initialized {
      display: block;
    }
  }

  &__slide {
    display: flex;
    flex-direction: column;
    height: auto;

    .sale-products__product {
      flex-grow: 1;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__slider-nav {
    display: flex;

    > * + * {
      margin-left: 8px;
    }
  }

  &__next,
  &__prev {
    color: $White;
    width: 28px;
    height: 28px;
    background-color: $GreenM;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 200ms ease;

    &:not(:disabled):hover {
      background-color: $Green2;
    }

    &:disabled {
      background-color: $LGray;
    }
  }
}
</style>
